import { makeStyles } from '@fluentui/react-components';
import { Lightbulb } from '@material-symbols-svg/react/rounded/w500';

import { SectionLabel } from '../components';
import { palette, tokens } from '../theme';

export const PatInstructions: React.FC = () => {
    const classes = useStyles();
    return (
        <aside className={classes.rightColumn}>
            <SectionLabel text="How to get a PAT" />
            <div className={classes.note}>
                <span className={classes.noteBullet}>
                    <Lightbulb className={classes.noteIcon} />
                </span>
                <div className={classes.noteLines}>
                    <p className={classes.noteHeading}>Create a Personal Access Token in Azure DevOps</p>
                    <ol className={classes.noteList}>
                        <li>
                            Open Azure DevOps → click your profile icon (top right) → <strong>User settings</strong> →{' '}
                            <strong>Personal access tokens</strong>.
                        </li>
                        <li>
                            Click <strong>+ New Token</strong>. Give it a name (e.g. <em>Time Tracker</em>) and pick an expiration date.
                        </li>
                        <li>
                            Under <strong>Scopes</strong>, choose <strong>Custom defined</strong> and tick both{' '}
                            <strong>Graph — Read</strong> and <strong>Work Items — Read &amp; Write</strong>. Those are all this app needs.
                        </li>
                        <li>
                            Click <strong>Create</strong>, copy the token (shown once), and paste it on the left.
                        </li>
                    </ol>
                    <p className={classes.noteFootnote}>
                        The token is stored only in your browser&rsquo;s local storage — never sent anywhere except Azure DevOps.
                    </p>
                </div>
            </div>
        </aside>
    );
};

const useStyles = makeStyles({
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        paddingLeft: tokens.spacingHorizontalXXL,
        borderLeft: `1px solid ${palette.cardBorder}`,
    },
    note: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: tokens.spacingHorizontalS,
        padding: tokens.spacingHorizontalM,
        backgroundColor: palette.panelMuted,
        border: `1px solid ${palette.cardBorder}`,
        borderRadius: tokens.borderRadiusLarge,
    },
    noteBullet: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        backgroundColor: palette.accentBg,
        flexShrink: 0,
        marginTop: '2px',
    },
    noteIcon: {
        width: '12px',
        height: '12px',
        color: palette.accentText,
    },
    noteLines: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        minWidth: 0,
    },
    noteHeading: {
        margin: 0,
        fontSize: '12.5px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    noteList: {
        margin: 0,
        paddingLeft: '18px',
        display: 'flex',
        flexDirection: 'column',
        gap: '3px',
        fontSize: '12px',
        color: tokens.colorNeutralForeground2,
        lineHeight: 1.45,
    },
    noteFootnote: {
        margin: 0,
        marginTop: '4px',
        fontSize: '11.5px',
        color: tokens.colorNeutralForeground3,
        fontStyle: 'italic',
    },
});
